/**
 * Constant for the different colors of quick keys.
 */
export enum QuickKeyColour {
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  BLUE = 'blue',
  PURPLE = 'purple',
  WHITE = 'white',
}

/**
 * Constant for the different types of quick key nodes (page, folder, quick key, etc).
 */
export enum QuickKeyNodeType {
  ROOT = 'root',
  PAGE = 'page',
  FOLDER = 'folder',
  QUICK_KEY = 'quick-key',
  BLANK = 'blank',
}

export const DEFAULT_ROWS = 5

export const DEFAULT_COLUMNS = 5

export const DEFAULT_QUICK_KEY = {
  color: QuickKeyColour.WHITE,
  isChild: 0,
  showImage: 1,
  columns: 1,
  rows: 1,
}

export const DEFAULT_FOLDER = DEFAULT_QUICK_KEY

export const DEFAULT_PAGE = {
  columns: DEFAULT_COLUMNS,
  rows: DEFAULT_ROWS,
}
